import type ArticleType from '~/client/components/Blog/shared/articles/BlogArticle/ArticleType';
import SimpleLink from '~/client/shared/SimpleLink';
import ArticleBody from './ArticleBody';
import ArticleImage from './styles/ArticleImage';
import Container from './styles/Container';
import type { BlogArticlesFragment } from '../../../graphql/BlogArticlesQuery.generated';

type Props = {
  article: BlogArticlesFragment['node'];
  type?: ArticleType;
  size: 'big' | 'small';
  showPreview?: boolean;
  gridArea?: string;
};

const getPostHref = (article: BlogArticlesFragment['node']) => {
  const section = article?.sectionHandle?.replace('blog-', '');
  return `/blog/${section}/${article?.handle}`;
};

const BlogArticle: FC<Props> = ({
  article,
  size,
  type = 'article_container',
  gridArea,
}) => (
  <SimpleLink
    className="[display:auto] xl:contents"
    href={getPostHref(article)}
  >
    <Container type={type} size={size} gridArea={gridArea}>
      <ArticleImage
        src={article?.smallImage}
        alt={article?.title}
        size={size}
        container={type}
      />
      <ArticleBody article={article} type={type} size={size} />
    </Container>
  </SimpleLink>
);

export default BlogArticle;
